<template>
  <div v-if="isVisible" class="captcha-overlay">
    <div class="captcha-container" v-if="captchaData">
      <div v-if="captchaData.isClickable">
        <clickable-captcha
          :captchaId="captchaData.captchaId"
          :captchaImageBase64="captchaData.image"
          :title="captchaData.title"
          :disabled="captchaTestMsg.length > 0 || checkCaptchaLoader"
          @input="submitCaptcha"
          @renew="renewCaptcha"
        />
      </div>
      <div v-else>
        <captcha
          :captchaId="captchaData.captchaId"
          :captchaImageBase64="captchaData.image"
          :title="captchaData.title"
          :disabled="captchaTestMsg.length > 0 || checkCaptchaLoader"
          @input="submitCaptcha"
          @renew="renewCaptcha"
        />
      </div>

      <!-- <h3>{{ captchaData.Title || 'Подтвердите, что вы не робот' }}</h3>
      
      <div class="captcha-image-wrapper">
        <img :src="captchaData.Image" alt="Captcha" />
      </div>

      <div class="captcha-input-block">
        <input 
          v-model="captchaValue" 
          type="text" 
          placeholder="Введите ответ" 
          @keyup.enter="submitCaptcha"
        />
        <button @click="submitCaptcha" :disabled="!captchaValue">Отправить</button>
      </div> -->

      <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import Captcha from "./Captcha.vue";
import ClickableCaptcha from "./ClickableCaptcha.vue";

export default {
  name: "CaptchaModal",
  components: {
    Captcha,
    ClickableCaptcha,
  },
  data() {
    return {
      isVisible: false,
      captchaValue: "",
      errorMessage: "",
      captchaData: null,
      onResolveCallback: null,

      captchaTestMsg: "",
      checkCaptchaLoader: false,
    };
  },
  created() {
    this.$captchaBus.$on("show-captcha", this.handleShowCaptcha);
  },
  beforeDestroy() {
    this.$captchaBus.$off("show-captcha", this.handleShowCaptcha);
  },
  methods: {
    // handleShowCaptcha({ captcha, onResolve }) {
    //   // console.log("show-captcha");
    //   this.captchaData = captcha;
    //   this.onResolveCallback = onResolve;
    //   this.captchaValue = "";
    //   this.errorMessage = "";
    //   this.isVisible = true;
    // },
    handleShowCaptcha(data) {
      this.captchaData = data.captcha;
      this.onResolveCallback = data.onResolve;
      this.captchaValue = '';
      this.isVisible = true;
    },
    async renewCaptcha() {
      // console.log("renew captcha");
      if (this.onResolveCallback) {
        this.isVisible = false;

        // Передаем управление обратно в интерцептор, который выполнит повторный запрос
        await this.onResolveCallback(null);
      }
    },
    async submitCaptcha(payload) {
      // console.log("submit captcha: " + payload.value);
      if (this.onResolveCallback) {
        this.isVisible = false;

        // Передаем управление обратно в интерцептор, который выполнит повторный запрос
        await this.onResolveCallback(payload.value);
      }
    },
  },
};
</script>

<style scoped>
.captcha-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.captcha-container {
  /* background: white; */
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 350px;
  width: 100%;

  color: white;
  background: #19191ceb;
  border-radius: 10px;
  border: 1px solid #5b5b5b;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
}
/* .captcha-image-wrapper {
  margin: 15px 0;
  border: 1px solid #ccc;
  display: inline-block;
}
.captcha-input-block {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.captcha-input-block input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.captcha-input-block button {
  padding: 8px 15px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
} */
.error-text {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}
</style>